import { post } from '../axios'

// 删除重定向设置
export function redirectUrl_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/delete`,
    map,
    option
  ).then(response => response)
}

// 下载模板
export function redirectUrl_downloadTemplate_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/downloadTemplate`,
    map,
    option
  ).then(response => response)
}

// 导出数据
export function redirectUrl_exportData_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/exportData`,
    map,
    option
  ).then(response => response)
}

// 导入数据
export function redirectUrl_importData_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/importData`,
    map,
    option
  ).then(response => response)
}

// 查询重定向设置
export function redirectUrl_listByCondition_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/listByCondition`,
    map,
    option
  ).then(response => response)
}

// 新增/编辑重定向设置
export function redirectUrl_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/save`,
    map,
    option
  ).then(response => response)
}
